/**
 * Supported cover image preview transformations.
 *
 * @type {Object<string>}
 */
export const PREVIEW_TRANSFORMATION_TYPES = {
    ORIGINAL: 'original',
    LARGE: 'large',
    MOBILE_PREVIEW: 'mobile_preview',
    MOBILE_STATIC_PREVIEW: 'mobile_static_preview',
    THUMB_LARGE: 'thumb_large'
};

/**
 * Default upload progress percentage.
 *
 * @type {number}
 */
export const DEFAULT_PROGRESS = 0;

/**
 *
 * @type {number}
 */
export const MAX_FILE_SIZE_IN_GB = 5;
